import { FILE_TYPES, MIME_TYPES } from 'www/constants'

export const VALIDATION_OPTIONS = {
  maxSizeMb: 16,
  allowedFileMimeTypes: [
    MIME_TYPES.jpg,
    MIME_TYPES.heic,
    MIME_TYPES.png,
    MIME_TYPES.pdf,
  ] as Array<typeof MIME_TYPES[keyof typeof MIME_TYPES]>,
  allowedFileTypes: [
    FILE_TYPES.jpg,
    FILE_TYPES.heic,
    FILE_TYPES.png,
    FILE_TYPES.pdf,
  ] as Array<typeof FILE_TYPES[keyof typeof FILE_TYPES]>,
  maxOverallSizeMb: 48,
  maxImagePixels: 120_000_000,
  minResolution: {
    width: 300,
    height: 300,
  },
}
